if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.quantityElement = this.querySelector('.quantity-input');
      const requiredOptionsSetting = ([] || []).map(x=>x.trim());
      this.requiredOptions = this.productData.options.filter(x=>requiredOptionsSetting.indexOf(x)>-1 || requiredOptionsSetting.indexOf('*')>-1);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          self.colorSwatches = self.querySelector('product-swatch.color-swatches');
          if (self.colorSwatches) {
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin',self.colorSwatches);
          }
        }, 10);
      }
    }

    openOptions() {
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    onVariantChange(event) {
      var image = event.detail.variant.featured_image;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.addToCartBtn = this.querySelector('.btn.add');

      this.listenEvents = ['sellingPlanChange'];
      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          this.updateButtonPrice();
        });
      });

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }

          this.updateButtonPrice();

          this.addToCartBtn.style.display = '';
          this.querySelector('.sold-out-message').style.display = 'none';
          //this.mainElement.querySelector('#qty-selector').style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.addToCartBtn.style.display = 'none';
          this.querySelector('.sold-out-message').style.display = '';
          //this.mainElement.querySelector('#qty-selector').style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
      	}
      });

      // Observe changes in the selling_plan input in the form
      this.observeSellingPlanInput();
      
      // Check initial price after a delay
      var self = this;
      setTimeout(function() {
        self.updateButtonPrice();
      }, 200);
    }

    updateButtonPrice() {
      var priceElement = this.addToCartBtn ? this.addToCartBtn.querySelector('.btn-price') : null;
      if(!priceElement) return;
      
      var priceToShow = null;
      
      // Check if there's an active subscription plan
      var form = this.closest('form') || this.closest('add-to-cart-form');
      if(!form) {
        form = document.querySelector('form[action*="/cart/add"]');
      }
      
      var sellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;
      
      if(sellingPlanInput && sellingPlanInput.value) {
        var currentVariant = this.mainElement.getCurrentVariant();
        
        if(currentVariant && currentVariant.selling_plan_allocations) {
          var planIdStr = String(sellingPlanInput.value);
          var planAlloc = currentVariant.selling_plan_allocations.find(x=>
            String(x.selling_plan_id) === planIdStr || 
            String(x.id) === planIdStr
          );
          
          if(planAlloc && planAlloc.price) {
            priceToShow = planAlloc.price;
          }
        }
      }
      
      // If no subscription price, use variant price
      if(!priceToShow) {
        var currentVariant = this.mainElement.getCurrentVariant();
        if(currentVariant && currentVariant.price) {
          priceToShow = currentVariant.price;
        }
      }
      
      // Update the price in the button
      if(priceToShow) {
        priceElement.innerHTML = ` - ${$s.formatMoney(priceToShow)}`;
      }
    }

    observeSellingPlanInput() {
      var self = this;
      var form = this.closest('form') || this.closest('add-to-cart-form');
      if(!form) {
        form = document.querySelector('form[action*="/cart/add"]');
      }
      
      if(form && window.MutationObserver) {
        var formObserver = new MutationObserver(function(mutations) {
          var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
          if(sellingPlanInput) {
            setTimeout(function() {
              self.updateButtonPrice();
            }, 50);
          }
        });
        
        formObserver.observe(form, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['value']
        });
        
        // Also check periodically in case the input is added later
        var checkInterval = setInterval(function() {
          var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
          if(sellingPlanInput) {
            self.updateButtonPrice();
            clearInterval(checkInterval);
          }
        }, 200);
        
        setTimeout(function() {
          clearInterval(checkInterval);
        }, 10000);
      }
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a';
        this.requiredMessage = 'Select ' + prep + ' ' + label;
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
      this.summaryButton = this.querySelector('.sticky-summary');
      this.optionElement = this.querySelector('.sticky-summary__option');
      this.addButton = this.querySelector('.btn.add');

      this.variantTitle = '';
      this.planName = '';

      // Keep the read-only summary in sync with the main form selection
      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.mainElement.addEventListener('sellingPlanChange', this.onSellingPlanChange.bind(this));

      // Tapping the summary scrolls up to the editable selectors
      if (this.summaryButton) {
        this.summaryButton.addEventListener('click', this.scrollToSelectors.bind(this));
      }

      // AddToCartForm only binds the first .btn.add, so forward this one to it
      if (this.addButton) {
        this.addButton.addEventListener('click', (e) => {
          e.preventDefault();
          var mainButton = this.mainElement.querySelector('add-to-cart-form .btn.add');
          if (mainButton && mainButton !== this.addButton) mainButton.click();
        });
      }
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
      this.bindSellingPlanInput();
      this.initSummary();
      // Re-sync once sibling/third-party widgets (e.g. Recharge) finish their initial render
      setTimeout(() => { this.bindSellingPlanInput(); this.initSummary(); }, 0);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
      if (this.formObserver) { this.formObserver.disconnect(); this.formObserver = null; }
    }

    // The selling_plan input may be injected by a third-party app (Recharge) and updated
    // WITHOUT firing a change event, so intercept its value setter and watch for re-injection.
    bindSellingPlanInput() {
      var input = this.mainElement.querySelector('input[name="selling_plan"]');
      if (input && input !== this.boundInput) {
        this.boundInput = input;
        var self = this;
        var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value');
        if (desc && desc.set) {
          Object.defineProperty(input, 'value', {
            configurable: true,
            get: function () { return desc.get.call(this); },
            set: function (v) { desc.set.call(this, v); self.syncPlan(); }
          });
        }
        this.syncPlan();
      }
      if (!this.formObserver) {
        var scope = this.mainElement.querySelector('add-to-cart-form') || this.mainElement;
        // Only react to (re)injection of the input; ongoing value changes are caught by the
        // intercepted setter. Re-syncing here would loop, since the summary lives inside this scope.
        this.formObserver = new MutationObserver(() => { this.bindSellingPlanInput(); });
        this.formObserver.observe(scope, { childList: true, subtree: true });
      }
    }

    syncPlan() {
      this.planName = this.readPlanName();
      this.renderSummary();
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }
    }

    initSummary() {
      var variant = (typeof this.mainElement.getCurrentVariant === 'function') ? this.mainElement.getCurrentVariant() : null;
      this.variantTitle = this.variantTitleFrom(variant);
      this.planName = this.readPlanName();
      this.renderSummary();
    }

    onVariantChange(event) {
      this.variantTitle = this.variantTitleFrom(event.detail.variant);
      this.renderSummary();
    }

    onSellingPlanChange(event) {
      this.syncPlan();
    }

    variantTitleFrom(variant) {
      if (!variant || !variant.title || variant.title === 'Default Title') return '';
      // Prefer the parenthetical short form: "1 Bottle (60 capsules)" -> "60 capsules"
      var match = variant.title.match(/\(([^)]+)\)/);
      return (match ? match[1] : variant.title).trim();
    }

    readPlanName() {
      // Empty selling_plan input means one-time purchase -> no plan in the summary
      var input = this.mainElement.querySelector('input[name="selling_plan"]');
      var planId = input && input.value ? String(input.value) : '';
      if (!planId) return '';
      // Map the selected plan id to its name via the product data (works for Recharge and the custom widget)
      var data = this.mainElement.productData;
      var groups = (data && data.sellingPlanGroups) || [];
      for (var i = 0; i < groups.length; i++) {
        var plans = groups[i].selling_plans || groups[i].sellingPlans || [];
        for (var j = 0; j < plans.length; j++) {
          if (String(plans[j].id) === planId) {
            // Drop the discount clause: "Delivery every 30 days with 10% discount" -> "Delivery every 30 days"
            return (plans[j].name || '').split(/\s+with\s+/i)[0].trim();
          }
        }
      }
      return '';
    }

    renderSummary() {
      if (!this.optionElement) return;
      var parts = [];
      if (this.variantTitle) parts.push(this.variantTitle);
      if (this.planName) parts.push(this.planName);
      var text = parts.join(' - ');
      // Skip no-op writes to avoid redundant DOM mutations and aria-live re-announcements
      if (this.optionElement.textContent === text) return;
      this.optionElement.textContent = text;
    }

    scrollToSelectors(event) {
      event.preventDefault();
      var target = this.mainElement.querySelector('product-variants') || this.mainElement.querySelector('product-selling-plan');
      if (!target) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector(':scope > div.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key);
              if(optionIndex>=0) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
        if(variant.featured_media) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
            dots: this.querySelector('.keen-dots'),
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 1) +'px)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
          breakpoints['(max-width: '+(parseInt(window.breakpoints.small)) +'px)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }
        breakpoints['(max-width: 600px)'] = {
          slidesPerView: 1.25,
          mode: "free-snap"
        };
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && this.desktopStyle=='carousel' )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: false,
          centered: false,
          slidesPerView: 5,
          spacing: 20,
          slidesToScroll: 1,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints: {
            "(min-width: 601px) and (max-width: 900px)":
              {
                slidesPerView: 5,
                spacing: 10,
                prevButton: this.querySelector('.keen-arrow.prev'),
                nextButton: this.querySelector('.keen-arrow.next'),
              },
            "(max-width: 600px)": {
              mode: "free-snap",
              slidesPerView: 4.5,
              vertical:true,
              centered:false,
              loop: true,
              spacing: 5
            },
          },
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dealElement = this.querySelector('.deal');
      this.retailElement = this.querySelector('.retail');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = e.detail.variant || e.detail.sellingPlan;
          if(!data) {
            data = this.mainElement.getCurrentVariant();
          }
        	if(data) {
            data = this.mainElement.getCurrentVariant();
            if(data.metafields && data.metafields.variant_hidden_subscriptions){
              var hiddenFields = data.metafields.variant_hidden_subscriptions.split('|');
              hiddenFields.forEach(function(e){
                var hidden = 'Delivery every '+e+' Days';
                setTimeout(()=>{
                  document.querySelectorAll('div[data-plans] select option').forEach(function(e){
                    if(e.innerHTML == hidden){
                        e.classList.add('hide');
                        e.disabled = true;
                        e.remove();
                    }
                  })
                }, 100);
              })
            }
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        		this.dealElement.innerHTML = $s.formatMoney(data.price * quantity);

            if(data.compare_at_price > data.price) {
              this.retailElement.classList.remove('hide');
              this.retailElement.innerHTML = $s.formatMoney(data.compare_at_price * quantity);
            } else {
              this.retailElement.classList.add('hide');
              this.retailElement.innerHTML = '';
            }
        	} else {
        		this.dealElement.innerHTML = '';
            this.retailElement.innerHTML = '';
        	}
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantInput = this.querySelector('[data-variant-id]');

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
      }, 10);
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.productData = this.mainElement.productData; 
      this.variantsElement = this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.customLabel = this.dataset.customLabel;

      this.buildOptionSelector();
      this.updatePrices();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    parseCustomLabel(label) {
      let parsedLabel = label;
      parsedLabel = parsedLabel.replace('[strong]', '<strong>')
      parsedLabel = parsedLabel.replace('[/strong]', '</strong>')
      parsedLabel = parsedLabel.replace('[bullet]', `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none"><circle cx="3" cy="3.5" r="3" fill="#8DA2EB"/></svg>`)
      return parsedLabel
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
  		var html = `
  			<div class="option-name"><strong>${this.label}</strong></div>
  			<div class="swatch-group flex justify-content-between"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
  
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var optionData = this.productData.variants.find(x => x.title === option.value);
        var packsQuantity = optionData.title.split('(')[0]    
        var unitsQuantity = optionData.title.split('(')[1]
        var freeShippingBar = "";
        
        // Get variant badge if it exists
        var variantBadge = "";
        // console.log('Checking variant badge for:', optionData);
        
        // Try to get variant badge from the variants-info div
        var variantInfoDiv = this.mainElement.querySelector(`[data-variant-id="${optionData.id}"][data-variant-badge]`);
        if (variantInfoDiv) {
          var badgeText = variantInfoDiv.getAttribute('data-variant-badge');
          var badgeHandle = $s.handleize(badgeText);
          variantBadge = `<div class="variant-badge ${badgeHandle}">${badgeText}</div>`;
          // console.log('Variant badge found in variants-info:', badgeText);
        } else if (optionData && optionData.metafields && optionData.metafields.custom && optionData.metafields.custom.variant_badge) {
          var badgeHandle = $s.handleize(optionData.metafields.custom.variant_badge);
          variantBadge = `<div class="variant-badge ${badgeHandle}">${optionData.metafields.custom.variant_badge}</div>`;
          // console.log('Variant badge found in metafields:', optionData.metafields.custom.variant_badge);
        }
        
        
        if (this.dataset.sitewideFs == "enabled") {
          var freeShippingBar = "<div class='free-shipping-bar'>Free Shipping</div>";
        } else {
          if(!packsQuantity.includes("1") || this.mainElement.getCurrentVariant().name == "VSL#3® Powder - 1 Box (30 packets)"){
            freeShippingBar = "<div class='free-shipping-bar'>Free Shipping</div>"
          } else{
            freeShippingBar = "";
          }
        }
        /*
        if(!packsQuantity.includes("1") || this.mainElement.getCurrentVariant().name == "VSL#3® Powder - 1 Box (30 packets)"){
          freeShippingBar = "<div class='free-shipping-bar'>FREE SHIPPING</div>"
        }else{
          freeShippingBar = "";
        }*/
  			
         // Calculate price per unit
         let pricePerUnit = null;
         let unitLabel = 'capsule'; // Default fallback
         if (optionData && typeof optionData.price === 'number' && unitsQuantity) {
           let match = unitsQuantity.match(/(\d+)/);
           let units = match ? parseInt(match[1], 10) : null;
           if (units && units > 0) {
             pricePerUnit = (optionData.price / 100) / units;
           }
           
           // Extract unit label from unitsQuantity and convert to singular
           // (e.g., "30 capsules)" -> "capsule", "30 sachets)" -> "sachet")
           let unitMatch = unitsQuantity.replace(')', '').trim().match(/\d+\s+(.+)/);
           if (unitMatch && unitMatch[1]) {
             let pluralUnit = unitMatch[1].trim();
             // Convert to singular
             if (pluralUnit.endsWith('ies')) {
               // countries -> country
               unitLabel = (pluralUnit.slice(0, -3) + 'y').toLowerCase();
             } else if (pluralUnit.endsWith('ches') || pluralUnit.endsWith('shes') || 
                        pluralUnit.endsWith('xes') || pluralUnit.endsWith('zes') || 
                        pluralUnit.endsWith('sses')) {
               // boxes -> box, classes -> class, matches -> match
               unitLabel = pluralUnit.slice(0, -2).toLowerCase();
             } else if (pluralUnit.endsWith('es')) {
               // capsules -> capsule, packets -> packet (remove only 's')
               unitLabel = pluralUnit.slice(0, -1).toLowerCase();
             } else if (pluralUnit.endsWith('s')) {
               // sachets -> sachet
               unitLabel = pluralUnit.slice(0, -1).toLowerCase();
             } else {
               unitLabel = pluralUnit.toLowerCase();
             }
           }
         }
  			html += `
          <div class="swatch" data-available="${option.available}" data-v-id="${optionData.id}">
            <input type="radio" id="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}" value="${$s.escapeDomAttribute(option.value)}" />
  				  <label for="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}">
              <div class="label-inner ${optionNameHandle}-${optionValueHandle}">
                <div>
                <div>
                <strong>${unitsQuantity ? '' + unitsQuantity.replace(')', '') : ''}</strong>
                </div>
                <div class='capsule-count flex align-items-center'>
                  ${optionData && typeof optionData.price === 'number' ? `<span class="variant-price">$${(optionData.price / 100).toFixed(2)}</span>` : ''} <span class='price-per-capsule'>${pricePerUnit ? `($${pricePerUnit.toFixed(2)}/${unitLabel})` : ''}</span>
                </div>
                </div>
                ${freeShippingBar}
                ${variantBadge}
                <div class="swatch-thumb">
                  ${optionData && optionData.featured_image ? `<img src="${optionData.featured_image.src}" class="lazyload" />` : ''}
                  <span class="savings"></span>
                  <span class="savings sub"></span>
                </div>
              </div>
            </label>
          </div>
  			`;
  		});

  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;
      
      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }

    updatePrices(){
      var singleVariant = this.productData.variants.find(x => x.metafields.variant_quantity === 1 || (x.title.trim()).charAt(0) == 1)
      var self = this;
      var listenEvents = ['variantChange','sellingPlanChange'];
      var data = null;

      listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          data = e.detail.variant || e.detail.sellingPlan;

          if(!data) {
            data = this.mainElement.getCurrentVariant();
          }
        	if(data ===  e.detail.sellingPlan) {
            this.productData.variants.forEach((v, i) => {
              setTimeout(() => {                
                self.querySelector(`[data-v-id="${v.id}"] .savings`) && v.metafields.variant_quantity && singleVariant && this.amountSaved(singleVariant.price, v.metafields.variant_quantity, v.selling_plan_allocations[0].price) > 0 ? self.querySelector(`[data-v-id="${v.id}"] .savings.sub`).innerHTML = 'Save $' + this.amountSaved(singleVariant.price, v.metafields.variant_quantity, v.selling_plan_allocations[0].price) : ''
              }, 10);
            })
        	}
        	if(data === e.detail.variant) {
            this.productData.variants.forEach((v, i) => {
              setTimeout(() => {                
                self.querySelector(`[data-v-id="${v.id}"] .savings`) && v.metafields.variant_quantity && singleVariant && this.amountSaved(singleVariant.price, v.metafields.variant_quantity, v.price) > 0 ? self.querySelector(`[data-v-id="${v.id}"] .savings`).innerHTML = 'Save $'+this.amountSaved(singleVariant.price, v.metafields.variant_quantity, v.price) : ''
              }, 10);
            })
        	}
        });
      });

    }
    amountSaved(orig, size, bulkprice) {
      return parseFloat(((orig * size) - bulkprice) * .01).toFixed(2);
    }

    percentageSaved(orig, size, bulkprice){
      return Math.round(((orig*size) - bulkprice ) / (orig*size) * 100)
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">${this.label}</label>
        <select id="${optionId}" name="swatch-${optionId}"></select>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>- Select -</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? ' - Sold Out' : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}
/*
REF: FEATURE PICKUP AVAILABILITY
if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('product-main');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('button');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'test');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}
*/


